/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { classNames } from 'primereact/utils';
import { ProgressSpinner } from 'primereact/progressspinner';

export interface OverLoadingProps {
  className?: string;
  loading?: boolean;
}

const Div = styled.div`
  .blur {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
`;

export const OverLoading: React.FC<PropsWithChildren<OverLoadingProps>> = ({ loading, className, children }) => {
  return (
    <>
      {loading ? (
        <Div className={classNames(className, 'w-full h-full')}>
          {children}
          <div className="blur">
            <div className="flex h-full w-full align-items-center">
              <ProgressSpinner
                style={{ width: '80px', height: '80px' }}
                strokeWidth="8"
                fill="var(--surface-ground)"
                animationDuration=".5s"
              />
            </div>
          </div>
        </Div>
      ) : (
        children
      )}
    </>
  );
};
